import { type ConfigContextState } from 'app/common/ConfigContext';
import { getMetricsSuffix } from 'app/config/metrics.config.helper';
import { getBackendUrl } from 'app/utils/api_url';

// FETCH URL
const getMatchGamesFetchUrl = (matchId: number, config: ConfigContextState) =>
  `${getBackendUrl()}/api/matches/${matchId}/games${getMetricsSuffix(config)}`;

const getMatchesFetchUrl = (tournamentId: number, config: ConfigContextState) =>
  `${getBackendUrl()}/api/tournaments/${tournamentId}/matches${getMetricsSuffix(config)}`;

const getTournamentBracketFetchUrl = (tournamentId: number, config: ConfigContextState) =>
  `${getBackendUrl()}/api/tournaments/${tournamentId}/bracket${getMetricsSuffix(config)}`;

export { getMatchGamesFetchUrl, getMatchesFetchUrl, getTournamentBracketFetchUrl };
